import React, { useState } from 'react';
import { BsPencilSquare, BsBook, BsX, BsArrowUp, BsArrowDown, BsCheckCircle } from 'react-icons/bs';
import styles from '../../HedefFormu.module.css';

const KitaplarCard = ({ data, onEdit }) => {
  const [showEditModal, setShowEditModal] = useState(false);

  const TARGET = {
    ulusalYazarlik: 2,
    uluslararasiYazarlik: 2,
    bkciYazarlik: 1,
    ulusalBolum: 2,
    uluslararasiBolum: 2,
    bkciBolum: 1,
    ulusalEditorluk: 1,
    uluslararasiEditorluk: 1,
    bkciEditorluk: 1
  };

  const completionStatus = {
    ulusalYazarlik: data.ulusalYazarlik >= TARGET.ulusalYazarlik,
    uluslararasiYazarlik: data.uluslararasiYazarlik >= TARGET.uluslararasiYazarlik,
    bkciYazarlik: data.bkciYazarlik >= TARGET.bkciYazarlik,
    ulusalBolum: data.ulusalBolum >= TARGET.ulusalBolum,
    uluslararasiBolum: data.uluslararasiBolum >= TARGET.uluslararasiBolum,
    bkciBolum: data.bkciBolum >= TARGET.bkciBolum,
    ulusalEditorluk: data.ulusalEditorluk >= TARGET.ulusalEditorluk,
    uluslararasiEditorluk: data.uluslararasiEditorluk >= TARGET.uluslararasiEditorluk,
    bkciEditorluk: data.bkciEditorluk >= TARGET.bkciEditorluk
  };
  
  const totalAuthorship = data.ulusalYazarlik + data.uluslararasiYazarlik + data.bkciYazarlik;
  const targetAuthorship = TARGET.ulusalYazarlik + TARGET.uluslararasiYazarlik + TARGET.bkciYazarlik;
  
  const totalChapters = data.ulusalBolum + data.uluslararasiBolum + data.bkciBolum;
  const targetChapters = TARGET.ulusalBolum + TARGET.uluslararasiBolum + TARGET.bkciBolum;
  
  const totalEditorship = data.ulusalEditorluk + data.uluslararasiEditorluk + data.bkciEditorluk;
  const targetEditorship = TARGET.ulusalEditorluk + TARGET.uluslararasiEditorluk + TARGET.bkciEditorluk;
  
  const totalContributions = totalAuthorship + totalChapters + totalEditorship;
  const targetTotal = targetAuthorship + targetChapters + targetEditorship;

  const handleEdit = () => {
    setShowEditModal(true);
  };

  return (
    <div className={styles.card} data-type="kitaplar">
      <div className={styles.cardHeader}>
        <h3 className={styles.cardTitle}>
          <BsBook className={styles.cardIcon} />
          Kitaplar
        </h3>
        <div className={styles.cardActions}>
          <button 
            className={styles.actionButton}
            onClick={handleEdit}
            aria-label="Kitapları düzenle"
          >
            <BsPencilSquare />
          </button>
        </div>
      </div>

      <div>
        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Kitap Yazarlığı</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Ulusal Yazarlık
              {completionStatus.ulusalYazarlik && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.ulusalYazarlik})</span>
            </span>
            <div className={styles.statValue}>{data.ulusalYazarlik}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Yazarlık
              {completionStatus.uluslararasiYazarlik && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasiYazarlik})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiYazarlik}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              BKCI Yazarlık
              {completionStatus.bkciYazarlik && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.bkciYazarlik})</span>
            </span>
            <div className={styles.statValue}>{data.bkciYazarlik}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalAuthorship >= targetAuthorship ? styles.targetComplete : styles.targetIncomplete}>
                {totalAuthorship} / {targetAuthorship}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Kitapta Bölüm Yazarlığı</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Ulusal Bölüm Yazarlığı
              {completionStatus.ulusalBolum && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.ulusalBolum})</span>
            </span>
            <div className={styles.statValue}>{data.ulusalBolum}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Bölüm Yazarlığı
              {completionStatus.uluslararasiBolum && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasiBolum})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiBolum}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              BKCI Bölüm Yazarlığı
              {completionStatus.bkciBolum && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.bkciBolum})</span>
            </span>
            <div className={styles.statValue}>{data.bkciBolum}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalChapters >= targetChapters ? styles.targetComplete : styles.targetIncomplete}>
                {totalChapters} / {targetChapters}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.formSection}>
          <h4 className={styles.formTitle}>Kitap Editörlüğü</h4>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Ulusal Editörlük
              {completionStatus.ulusalEditorluk && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.ulusalEditorluk})</span>
            </span>
            <div className={styles.statValue}>{data.ulusalEditorluk}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              Uluslararası Editörlük
              {completionStatus.uluslararasiEditorluk && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.uluslararasiEditorluk})</span>
            </span>
            <div className={styles.statValue}>{data.uluslararasiEditorluk}</div>
          </div>
          <div className={styles.statRow}>
            <span className={styles.statLabel}>
              BKCI Editörlük
              {completionStatus.bkciEditorluk && <BsCheckCircle className={styles.targetComplete} />}
              <span className={styles.targetInfo}>(Hedef: {TARGET.bkciEditorluk})</span>
            </span>
            <div className={styles.statValue}>{data.bkciEditorluk}</div>
          </div>
          <div className={styles.targetStatus}>
            <div className={styles.targetItem}>
              <span>Toplam:</span>
              <span className={totalEditorship >= targetEditorship ? styles.targetComplete : styles.targetIncomplete}>
                {totalEditorship} / {targetEditorship}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.totalSection}>
        <div className={styles.totalRow}>
          <span>Toplam Kitap Yazarlığı</span>
          <div>{totalAuthorship} / {targetAuthorship}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam Bölüm Yazarlığı</span>
          <div>{totalChapters} / {targetChapters}</div>
        </div>
        <div className={styles.totalRow}>
          <span>Toplam Editörlük</span>
          <div>{totalEditorship} / {targetEditorship}</div>
        </div>
        <div className={styles.totalRow} style={{ marginTop: '12px', fontWeight: 'bold' }}>
          <span>Toplam Katkı</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {totalContributions} / {targetTotal}
            <span className={totalContributions >= targetTotal ? styles.trendUp : styles.trendDown}>
              {totalContributions >= targetTotal ? <BsArrowUp /> : <BsArrowDown />}
              {Math.abs(targetTotal - totalContributions)}
            </span>
          </div>
        </div>

        <div className={styles.progressBar}>
          <div 
            className={styles.progressFill} 
            style={{ width: `${(totalContributions / targetTotal) * 100}%` }} 
          />
          <span className={styles.progressLabel}>
            {`${((totalContributions / targetTotal) * 100).toFixed(1)}% (Hedef: ${targetTotal})`}
          </span>
        </div>
      </div>

      {showEditModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal} data-type="kitaplar">
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>
                <BsBook /> Kitap Hedeflerini Düzenle
              </h2>
              <button 
                className={styles.actionButton}
                onClick={() => setShowEditModal(false)}
                aria-label="Kapat"
              >
                <BsX size={24} />
              </button>
            </div>
            
            <form className={styles.modalForm}>
              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Kitap Yazarlığı</h3>
                <p className={styles.detailsLabel}>
                  Kitaplar (Ulusal, Uluslararası ve Web of Science Book Citation Index)
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Ulusal Yazarlık (Hedef: {TARGET.ulusalYazarlik})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.ulusalYazarlik}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Yazarlık (Hedef: {TARGET.uluslararasiYazarlik})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiYazarlik}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>BKCI Yazarlık (Hedef: {TARGET.bkciYazarlik})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.bkciYazarlik}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Kitapta Bölüm Yazarlığı</h3>
                <p className={styles.detailsLabel}>
                Kitaplar (Ulusal, Uluslararası ve Web of Science Book Citation Index)
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Ulusal Bölüm (Hedef: {TARGET.ulusalBolum})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.ulusalBolum}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Bölüm (Hedef: {TARGET.uluslararasiBolum})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiBolum}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>BKCI Bölüm (Hedef: {TARGET.bkciBolum})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.bkciBolum}
                      min="0"
                    />
                  </div>
                </div>
              </div>

              <div className={styles.formSection}>
                <h3 className={styles.formTitle}>Kitap Editörlüğü	</h3>
                <p className={styles.detailsLabel}>
                  Kitaplar (Ulusal, Uluslararası ve Web of Science Book Citation Index)
                </p>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Ulusal Editörlük (Hedef: {TARGET.ulusalEditorluk})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.ulusalEditorluk}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Uluslararası Editörlük (Hedef: {TARGET.uluslararasiEditorluk})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.uluslararasiEditorluk}
                      min="0"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>BKCI Editörlük (Hedef: {TARGET.bkciEditorluk})</label>
                    <input 
                      type="number" 
                      className={styles.formInput}
                      value={data.bkciEditorluk}
                      min="0"
                    />
                  </div>
                </div>
              </div>
            </form>

            <div className={styles.buttonContainer}>
              <button 
                className={styles.cancelButton}
                onClick={() => setShowEditModal(false)}
              >
                İptal
              </button>
              <button className={styles.saveButton}>
                Kaydet
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KitaplarCard; 